<div *ngIf="subGroups  as sGroups">
    <div class="grp" *ngIf="sGroups.length; else noSubGroup" [@listAnimation]="sGroups.length">
        <div *ngFor="let item of sGroups">
            <div class="grp-item" (click)="subGroupClick(item)">
                {{item.name}}
            </div>
        </div>
    </div>
</div>